import { OfferData } from '@wwe-portal/entities/offer.type';
import { useNavigationState } from '@wwe-portal/web/hooks/offer/category-navigation-state';
import {
  specialOfferPageIsScrolling,
  specialOfferSectionIsScrolling,
} from '@wwe-portal/web/libs/analytics/offer';
import { ANALYTICS_VIEWED_LIMIT_MS } from '@wwe-portal/web/utils/config';
import debounce from 'lodash.debounce';
import { useEffect } from 'react';

function camelToSnake(str) {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}

const debounceSection = debounce((activeId: string, displayedItems: any[]) => {
  specialOfferSectionIsScrolling('special_offers', displayedItems);
  specialOfferPageIsScrolling(activeId);
}, ANALYTICS_VIEWED_LIMIT_MS);

export const useSendSectionViewed = (offerMap: Map<string, OfferData>) => {
  // Analytics hooks
  const activeId = useNavigationState((state) => state.activeId);

  useEffect(() => {
    if (activeId) {
      const displayedItems: any[] = [];
      let index = 0;
      let position = 0;
      offerMap.forEach((value) => {
        if (camelToSnake(value.categoryId) === activeId) {
          position = index;
          displayedItems.push({
            offerId: value.OffersID,
            offerItems: value.offerItems ?? [],
            position,
          });
        }
        index++;
      });
      debounceSection(activeId, displayedItems);
    }
  }, [activeId]);

  return null;
};
